export enum LoadingText {
    LOADING = "Loading...",
    APPROVING = "Approving...",
    CHECKING_ALLOWANCE = "Checking allowance...",
    AUTHENTICATING = "Authenticating...",
    CONNECTING = "Connecting...",
    DISCONNECTING = "Disconnecting...",
}

export enum ActionText {
    VOTING = "Voting...",
    MINTING = "Minting...",
    REDEEMING = "Redeeming...",
    STAKING = "Staking...",
    LOCKING = "Locking...",
    WITHDRAWING = "Withdrawing...",
    STARTING_WITHDRAWAL = "Starting withdrawal...",
    UNSTAKING = "Unstaking...",
    UPDATING = "Updating...",
}

export enum Unicode {
    MDASH = "\u2014",
}
